"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitDeleteUploadedFileF = void 0;
var tslib_1 = require("tslib");
var createErrorAction_1 = require("./../../../actionCreators/createErrorAction");
var takeGaurd_1 = require("./../../../utilities/takeGaurd");
var effects_1 = require("redux-saga/effects");
var selectState_1 = require("../../../state/selectState");
var storage_1 = require("firebase/storage");
var deleteUploadedFilesSaga_1 = require("../../sagas/delete/deleteUploadedFilesSaga");
var fixConstants_1 = require("../../../constants/fixConstants");
var storage_2 = require("firebase/storage");
var description = 'submitDeleteUploadedFileF';
var submitDeleteUploadedFileF = function () {
    var action, uploadedFileId, state, workspaceId, uploadedFile, path, items, storageRef, childRef, pathPartsMutable, fileName, thumbPath, thumbRef, _a;
    var _b;
    var _c;
    return tslib_1.__generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                if (!1) return [3 /*break*/, 11];
                return [4 /*yield*/, (0, takeGaurd_1.takeGaurd)('SUBMIT_DELETE_UPLOADED_FILE_ACTION')];
            case 1:
                action = _d.sent();
                uploadedFileId = action.uploadedFileId;
                return [4 /*yield*/, (0, effects_1.select)(selectState_1.selectState)];
            case 2:
                state = _d.sent();
                workspaceId = state.currentWorkspaceId;
                uploadedFile = uploadedFileId
                    ? (_c = state === null || state === void 0 ? void 0 : state.uploadedFiles) === null || _c === void 0 ? void 0 : _c[uploadedFileId].data
                    : null;
                path = uploadedFile === null || uploadedFile === void 0 ? void 0 : uploadedFile.path;
                if (!(uploadedFile && uploadedFileId && workspaceId)) return [3 /*break*/, 8];
                items = (_b = {},
                    _b[uploadedFileId] = {
                        data: uploadedFile,
                        workspaceId: workspaceId,
                    },
                    _b);
                return [4 /*yield*/, (0, effects_1.spawn)(deleteUploadedFilesSaga_1.deleteUploadedFilesSaga, { items: items })];
            case 3:
                _d.sent();
                if (!path) return [3 /*break*/, 7];
                storageRef = (0, storage_2.ref)((0, storage_1.getStorage)());
                childRef = (0, storage_2.ref)(storageRef, path);
                (0, storage_2.deleteObject)(childRef);
                pathPartsMutable = path.split('/');
                fileName = pathPartsMutable[pathPartsMutable.length - 1];
                pathPartsMutable[pathPartsMutable.length - 1] =
                    fixConstants_1.THUMB_FILE_NAME_PREFIX + fileName;
                thumbPath = pathPartsMutable.join('/');
                thumbRef = (0, storage_2.ref)(storageRef, thumbPath);
                _d.label = 4;
            case 4:
                _d.trys.push([4, 6, , 7]);
                return [4 /*yield*/, (0, storage_2.deleteObject)(thumbRef)];
            case 5:
                _d.sent();
                return [3 /*break*/, 7];
            case 6:
                _a = _d.sent();
                return [3 /*break*/, 7];
            case 7: return [3 /*break*/, 10];
            case 8: return [4 /*yield*/, (0, effects_1.put)((0, createErrorAction_1.createErrorAction)({
                    description: description,
                }))];
            case 9:
                _d.sent();
                _d.label = 10;
            case 10: return [3 /*break*/, 0];
            case 11: return [2 /*return*/];
        }
    });
};
exports.submitDeleteUploadedFileF = submitDeleteUploadedFileF;
